
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.86 14.82H7a.5.5 0 00-.5.5v8.25c0 .28.22.5.5.5h3.86a.5.5 0 00.5-.5v-8.25a.5.5 0 00-.5-.5zm-.5 8.25H7.5v-7.25h2.86v7.25zM23.5 6.58h-3.86a.5.5 0 00-.5.5v16.5c0 .27.22.5.5.5h3.86a.5.5 0 00.5-.5V7.07a.5.5 0 00-.5-.5zm-.5 16.5h-2.86V7.57H23v15.5zm-5.9-12.02h-3.87a.5.5 0 00-.5.5v12.02c0 .27.23.5.5.5h3.86a.5.5 0 00.5-.5V11.56a.5.5 0 00-.5-.5zm-.5 12.02h-2.87V12.06h2.86v11.02zM14.62 8.43l.12.02a.5.5 0 00.48-.39L16.98.6a.5.5 0 00-.37-.6.5.5 0 00-.6.37l-1.76 7.47a.5.5 0 00.37.6zM8.97.32c-.07-.2-.29-.37-.48-.34A.5.5 0 008 .34L4.3 13.08.98.35A.5.5 0 000 .6l3.8 14.5a.5.5 0 00.48.37.5.5 0 00.48-.36L8.52 2.18l2.58 8.04c.09.26.37.4.63.32a.5.5 0 00.32-.63L8.97.32z"}})])
          )
        }
      }
    